import { render } from "./AudienceAddGroupButton.vue?vue&type=template&id=649633e4&scoped=true"
import script from "./AudienceAddGroupButton.vue?vue&type=script&lang=js"
export * from "./AudienceAddGroupButton.vue?vue&type=script&lang=js"

import "./AudienceAddGroupButton.vue?vue&type=style&index=0&id=649633e4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649633e4"]])

export default __exports__